import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipe } from './filter.pipe';
import { MarkdownPipe } from './markdown.pipe';

@NgModule({
  declarations: [
    FilterPipe,
    MarkdownPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FilterPipe,
    MarkdownPipe
  ]
})
export class PipesModule { }
